import script from "./TagsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsWidget.vue?vue&type=script&setup=true&lang=js"

import "./TagsWidget.vue?vue&type=style&index=0&id=356a4bfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356a4bfc"]])

export default __exports__